import React from 'react';
import { css } from '@emotion/css';
import InfoCard from 'molecules/InfoCard';


import { CircularProgress } from '@mui/material';

import CheckCircle from 'assets/icons/check-circle.svg';

type BookingCardProps = {
    title: string
    content: string
    duration: string
    isLoadingServiceDetails: boolean
}

const BookingCard = ({ title, content, duration, isLoadingServiceDetails }: BookingCardProps) => {

    const getTextDuration = (time: string) => {
        var parts = time.split(':');
        var hours = parseInt(parts[0]);
        var minutes = parseInt(parts[1]);
        var seconds = parseInt(parts[2]);
      
        var result = [];
      
        if (hours > 0) {
            result.push(hours + ' timer');
        }
      
        if (minutes > 0) {
            result.push(minutes + ' minutter');
        }
      
        if (seconds > 0) {
            result.push(seconds + ' sekunder');
        }
      
        return result.join(' ');
    };

    return (
        <div className={styles.container}>
            <InfoCard title={title} icon={<img src={CheckCircle} alt='check'/>}>
                <div className={styles.wrapper}>
                    <div className={styles.infoRow}>
                        <span className={styles.contentText}>{content}</span>
                    </div>
                    <span className={styles.durationText}>{getTextDuration(duration)}</span>
                </div>
            </InfoCard>
            {isLoadingServiceDetails && (
                <div className={styles.loader}>
                    <CircularProgress/>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: css({
        position: 'relative',
        display: 'inline-block',
    }),
    wrapper: css({
        height: '72%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    }),
    contentText: css({
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#605E5C',
    }),
    infoRow: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',
    }),
    durationText: css({
        fontSize: '12px',
        lineHeight: '1rem',
        fontWeight: '700',
    }),
    loader: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        background: 'rgba(255,255,255,0.6)',
        borderRadius: '4px',
        padding: '0.25rem',
    }),
};

export default BookingCard;
